export enum ICepTypes {
  GET_CEP_REQUEST = '@cep/GET_CEP_REQUEST',
  GET_CEP_SUCCESS = '@cep/GET_CEP_SUCCESS',
  GET_CEP_FAILURE = '@cep/GET_CEP_FAILURE',
  CLEAR_CEP_REQUEST = '@cep/CLEAR_CEP_REQUEST',
}

export interface IGetCepRequestAction {
  type: typeof ICepTypes.GET_CEP_REQUEST;
  payload: {
    cep: string;
  };
}
export interface IGetCepSuccessAction {
  type: typeof ICepTypes.GET_CEP_SUCCESS;
  payload: {
    cep: ICep;
  };
}
export interface IGetCepFailureAction {
  type: typeof ICepTypes.GET_CEP_FAILURE;
}

export interface IClearCepAction {
  type: typeof ICepTypes.CLEAR_CEP_REQUEST;
}

export type ICepActionsType =
  | IGetCepRequestAction
  | IGetCepSuccessAction
  | IGetCepFailureAction
  | IClearCepAction;

export interface ICep {
  cep: string;
  state: string;
  city: string;
  street: string;
  neighborhood: string;
}

export interface ICepState {
  loading: boolean;
  cep: ICep | null;
}
